import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../enum/enum";
import { toast } from "react-toastify";
import { useAuth } from "../context/authContext";
import { useLoader } from "../context/loaderContext";
let debounceId = null;

const SignUp = () => {
    const {
        setToken,
        setUserId,
        setSessionId,
        setAccountId,
        setName,
        setPrefix,
        setEmail,
        setMobile,
        accountId,
    } = useAuth();
    const { showLoader, hideLoader } = useLoader();
    const location = useLocation();
    const navigate = useNavigate();
    // const { accountId } = location.state || {};
    const [isSponsorValid, setIsSponsorValid] = useState(null);
    const [loading, setLoading] = useState(false);
    const [sponsorName, setSponsorName] = useState("");
    const [fetchedAccount, setFetchedAccount] = useState("");
    const {
        register,
        handleSubmit,
        watch,
        setError,
        setValue,
        clearErrors,
        formState: { errors, isValid }
    } = useForm({
        mode: "onChange"
    });

    const { referral } = useParams();
    localStorage.setItem("setShowSale", '');

    const bscParams = {
        chainId: '0x38', // 56 in hex
        chainName: 'Binance Smart Chain',
        nativeCurrency: {
            name: 'BNB',
            symbol: 'BNB',
            decimals: 18,
        },
        rpcUrls: ['https://bsc-dataseed.binance.org/'],
        blockExplorerUrls: ['https://bscscan.com/'],
    };

    const formatEmail = (add) => {
        let address = add.slice(-10);
        address = address + "@gmail.com";
        return address;
    }

    const handleSignUp = async (data) => {
        try {
            if (!isSponsorValid) {
                setError("sponsorId", {
                    type: "manual",
                    message: "Invalid Sponsor ID."
                });
                return;
            }

            if (!fetchedAccount) {
                toast.error("Wallet is not connected.");
                return;
            }
            setLoading(true);
            const url = `${BaseUrl}API/InitiateTransactionMetaMask`;

            // let name1 = fetchedAccount;
            // name1 = `user_${name1.slice(-5)}`

            const body = {
                RefrelName: sponsorName,
                MetaMaskAddress: fetchedAccount,
                Name: data.name,
                Mobile: data.mobile,
                // Email: formatEmail(fetchedAccount),
                Email: data.email,
                RefrelUserID: data.sponsorId,
            };

            const res = await axios.post(url, body);

            if (res.data.statusCode == 1 || res.data.statuscode == 1) {
                toast.success(res.data.msg || "Registered successfully.");
                setTimeout(() => {
                    navigate('/login');
                }, 500);
            } else {
                toast.error(res.data.msg || "Failed to register", { toastId: "sign_up" });
            }
            setTimeout(() => {
                setLoading(false);
            }, 500);
        } catch (e) {
            setTimeout(() => {
                setLoading(false);
            }, 500);
            toast.error(e.message || "Failed to register.", { toastId: "sign_up" });
        }
    }

    const handleSponsor = async (value) => {
        try {
            setIsSponsorValid(null);
            setSponsorName("");
            if (value) {
                const url = `${BaseUrl}API/CheckRefrel?userID=${value}`;

                const res = await axios.get(url);

                if (res.data != null) {
                    setIsSponsorValid(true);
                    setSponsorName(res.data);
                    clearErrors("sponsorId");
                } else {
                    setIsSponsorValid(false);
                    setError("sponsorId", {
                        type: "manual",
                        message: "Invalid Sponsor ID."
                    });
                }
            }
        } catch (e) {
            console.log(e.message);
        }
    }

    const handleSponsorChange = async (e, refe) => {
        try {
            let { value } = refe ? { value: refe } : e.target;

            clearTimeout(debounceId);
            debounceId = setTimeout(() => {
                handleSponsor(value);
            }, 500);
        } catch (e) {
            console.log(e.message);
        }
    }

    const getAccounts = async () => {
        try {
            if (!window.ethereum) {
                setError("Wallet not found.");
                return;
            }
            const existingAccounts = await window.ethereum.request({ method: "eth_accounts" });

            if (existingAccounts.length > 0) {
                switchToBSC(existingAccounts[0]);
                return;
            }

            const accs = await window.ethereum.request({ method: "eth_requestAccounts" });

            switchToBSC(accs[0]);
        } catch (err) {
            setError("Error fetching accounts: " + err.message);
        }
    };

    const switchToBSC = async (id) => {
        try {
            await window.ethereum?.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: bscParams.chainId }],
            });

            setFetchedAccount(id);
            handleLogin(id);
        } catch (switchError) {
            // This error code means the chain hasn't been added to MetaMask
            if (switchError.code === 4902) {
                try {
                    await window.ethereum?.request({
                        method: 'wallet_addEthereumChain',
                        params: [bscParams],
                    });

                    setFetchedAccount(id);
                    handleLogin(id);
                } catch (addError) {

                }
            } else {

            }
        }
    }

    const handleLogin = async (acc) => {
        try {
            console.log("login started...");
            const url = `${BaseUrl}/MetaMask/LoginWithMetamask?Address=${acc}`;
            showLoader();
            const res = await axios.post(url);
            // console.log("res: ", res?.data);
            if (res.data?.statuscode == 1) {
                toast.success(res.data.msg || "Login successfully.")
                // console.log("statuscode 1");

                const userAuth = {
                    token: res.data.data?.session,
                    email: res.data.data?.emailID,
                    mobile: res.data.data?.mobileNo,
                    name: res.data.data?.name,
                    sessionId: res.data.data?.sessionID,
                    userId: res.data.data?.userID,
                    prefix: res.data.data?.prefix,
                    accountId: acc,
                };
                // console.log("saved data");
                localStorage.setItem("userAuth", JSON.stringify(userAuth));
                setUserId(userAuth.userId);
                setToken(userAuth.token);
                setSessionId(userAuth.sessionId);
                setAccountId(acc);
                setPrefix(userAuth.prefix);
                setName(userAuth.name);
                setEmail(userAuth.email);
                setMobile(userAuth.mobile);
                // console.log("navigation ");

                setTimeout(() => {
                    navigate('/dashboard', { state: { loadBalance: true } });
                }, 200);
            } else if (res.data?.statuscode == 2) {
                // toast.success(res.data.msg || "User not found.")
                // navigate('/signup', {
                //     state: {
                //         accountId: acc
                //     }
                // });
            } else {
                // console.log("statuscode is nither 1 or 2: ");
                toast.error(res.data.msg || "Something went wrong.")
                // setError(res.data.msg || "Something went wrong.");
            }
            hideLoader();
        } catch (e) {
            hideLoader();
            console.log("catch: ", e.message);
            toast.error(e.messsage || "Something went wrong")
            // setError("Something went wrong.");
        }
    }

    useEffect(() => {
        // if (!accountId) {
        getAccounts();
        // } else {
        //     handleLogin(accountId);
        // }
        if (referral) {
            handleSponsorChange(null, referral);
        } else {
            setValue("sponsorId", "TM10009");
            handleSponsorChange(null, "TM10009");
        }
    }, [accountId])

    return (
        <>
            <div className="row m-0" style={{ background: "rgb(177, 72, 76)", minHeight: "100vh" }}>
                <div className="col-lg-5 position-relative overflow-hidden cus-login-height bg-dark-200 d-none d-lg-block">
                    <div className="circle-top"></div>
                    <div><img src="/assets/images/logo-icon.svg" alt="Logo-Dark" className="circle-bottom" /></div>
                    <div className="d-flex align-items-center z-1 position-relative h-n80">
                        <div className="row justify-content-center w-100">
                            <div className="col-lg-7">
                                <h2 className="text-white f-s-40 m-b-16 m-t-0 lh-base"> Welcome to <br /> Tether Mine </h2>
                                <span className="op-75 f-s-16 text-white d-block m-b-16 lh-base">Tether Mine helps developers to build organized and well coded <br /> dashboards full of beautiful and rich modules. </span>
                                <button type="button" className="btn btn-cus btn-primary cus-btn-primary0 cus-view-btn-primary">Learn More</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-7 text-light">
                    <div className="d-flex align-items-start align-items-lg-center justify-content-center cus-h-50 mt-4" style={{ padding: "0px 21px" }}>
                        <form onSubmit={handleSubmit(handleSignUp)}>
                            <div className="row p-20 w-100 h-100">
                                <div className="col-md-12 text-center">
                                    <h4 className="f-w-700 f-s-24 m-t-24 m-b-8">
                                        Create your account
                                    </h4>
                                    <span className="f-s-14 d-block mat-body-1 m-t-8">
                                        Connect Your BEP20 (Binance Blockchain) Wallet.
                                    </span>

                                    <div className="or-border m-t-30 f-s-16 f-w-500 text-center">or sign in with</div>

                                </div>
                                <div className="col-lg-6 max-width-form">
                                    <div className="form-container">
                                        {/* <div className="divider">or sign in with</div> */}
                                        <div className="mb-2 cus-lable-area cus-relative-input">
                                            <label className="form-label">Sponsor ID</label>
                                            <input
                                                {...register("sponsorId", {
                                                    required: "Sponsor ID is required",
                                                    onChange: handleSponsorChange
                                                })}
                                                defaultValue={referral}
                                                // onChange={handleSponsorChange}
                                                type="text" className="form-control cus-form-control"
                                            />
                                            {
                                                isSponsorValid == true ?
                                                    <span className="check text-success">✔</span> :
                                                    (isSponsorValid == false && <span className="cross text-danger">✖</span>)
                                            }
                                            {sponsorName && (
                                                <div className="text-end" style={{ position: "absolute", color: "black", right: "0" }}>
                                                    <span>{sponsorName} </span>
                                                </div>
                                            )}
                                            {errors.sponsorId && <span className="error-fields">{errors.sponsorId?.message}</span>}
                                        </div>

                                        <div className="mb-2 cus-lable-area">
                                            <label className="form-label">Email Address</label>
                                            <input {...register("email", {
                                                required: "Email is required", pattern: {
                                                    message: "Enter a valid email.",
                                                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                                }
                                            })} type="text" className="form-control cus-form-control" />
                                            {errors.email && <span className="error-fields">{errors.email?.message}</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 max-width-form">
                                    <div className="form-container">
                                        <div className="mb-2 cus-lable-area">
                                            <label className="form-label">Name</label>
                                            <input {...register("name", { required: "Name is required" })} type="text" className="form-control cus-form-control" />
                                            {errors.name && <span className="error-fields">{errors.name?.message}</span>}
                                        </div>

                                        <div className="mb-2 cus-lable-area">
                                            <label className="form-label">Mobile Number</label>
                                            <input {...register("mobile", {
                                                required: "Mobile is required",
                                                minLength: {
                                                    message: "Invalid mobile number",
                                                    value: 10
                                                },
                                                maxLength: {
                                                    message: "Invalid mobile number",
                                                    value: 12
                                                },
                                            })} type="text" className="form-control cus-form-control" />
                                            {errors.mobile && <span className="error-fields">{errors.mobile?.message}</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12" style={{ padding: "10px" }}>
                                    <div className="mb-2 cus-lable-area">
                                        <label className="form-label">
                                            BEP20 (Binance Chain) Wallet Address
                                        </label>
                                        <div className="input-group mb-2">
                                            <input type="text" className="form-control cus-form-control cus-input-disabled"
                                                defaultValue={fetchedAccount} disabled
                                            // aria-label="Recipient's username" aria-describedby="basic-addon2"
                                            />
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" id="remember" />
                                            <label className="form-check-label" for="remember">I Agree to the</label>
                                            <span className="cus-privacy-content"> <Link to="#">Terms & Privacy</Link> </span>
                                        </div>
                                    </div>

                                    <div data-v-2ef07470="" data-v-c3280d72="" className="form-group security-verification">
                                        <button type="submit"
                                            // disabled={!isSponsorValid}
                                            disabled={loading || !isValid || !isSponsorValid}
                                            className={`sign-in-btn mt-2 ${((!isValid || isSponsorValid !== true) ? "disabled" : "")}`}
                                        >Connnect To Register</button>
                                    </div>
                                    <div className="bottom-text text-center">
                                        Already have an account? <Link to="#"> Sign In</Link>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div >
        </>
    )
}

export default SignUp;